import { useDeleteProjectItems } from '@customink/project-service-react-components';
import { SYNC_STRATEGIES } from '@customink/project-service-types';
import { useCallback } from 'react';

export const useDeleteItems = () => {
  const [trigger, result] = useDeleteProjectItems();
  const curriedTrigger = useCallback(
    (projectItemIds: string[]) =>
      trigger(projectItemIds, SYNC_STRATEGIES.CORE_ORDER),
    [trigger],
  );
  return [curriedTrigger, result] as const;
};
